import "../style.css";
import SEO from "../components/SEO";
import SiteFooter from "../components/SiteFooter";


function Contact() {
  return (


    <>

<SEO
  title="Contact Lappy Laptops"
  description="Visit Lappy Laptops shop in Namakkal or contact via phone or WhatsApp for laptop purchase and service."
  url="https://lappylaptops.com/contact"
/>
















    <div className="contact-page">
      {/* HEADER */}
      <div className="contact-header">
        <h2>Contact Us</h2>
        <p>We’re happy to help you choose the right laptop</p>
      </div>

      {/* CONTENT */}
      <div className="contact-wrapper">
        {/* LEFT INFO */}
        <div className="contact-info">
          <h3>Get in Touch</h3>

          <p>
            📞{" "}
            <a href="tel:+918838619488" className="contact-email-link">
              +91 8838619488
            </a>
          </p>
          <p>✉️ <a href="mailto:lappylaptopsales@gmail.com" className="contact-email-link">lappylaptopsales@gmail.com</a></p>
          <p>📍 129 Salapalayam Road, Reddipatti, Namakkal, TamilNadu 637002</p>
          <p>📍 Lappy Laptops, 27, Devangar Street, Thathiengarpettai, Musiri-Tk, Trichy-Dt, Pincode: 621214. Landmark: Mini Radios.</p>

          <a
            href="https://wa.me/918838619488"
            target="_blank"
            rel="noreferrer"
            className="whatsapp-btn"
          >
            WhatsApp Us
          </a>
        </div>

        {/* RIGHT MAP */}
        <div className="contact-map">
          <iframe
            title="Lappy Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.730200578514!2d78.22037987429323!3d11.207586751094425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babc94be384bbb3%3A0xcdd0430efbea64f3!2sLappy%20Used%20Laptops%20Sales!5e0!3m2!1sen!2sin!4v1770279618891!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>




 <SiteFooter />

</>



  );
}

export default Contact;










